/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ icon: NonNullable<unknown> }} Personas_Icon_Default_HintInputs */



/**
* | output |
* | --- |
* | "Default: {icon}" |
*
* @param {Personas_Icon_Default_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_icon_default_hint = /** @type {((inputs: Personas_Icon_Default_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_Icon_Default_HintInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Standard: ${i?.icon}`)
	return /** @type {LocalizedString} */ (`Default: ${i?.icon}`)
});